import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import commonFormMeta from '@Shared/components/form/commonFormMeta';

export interface IListOfCardsToBeRenewedMeta{
  bank: FormInputMeta;
  agency: FormInputMeta,
  cardType: FormInputMeta,
  nbMonths: FormInputMeta,
  internetOrder: FormInputMeta,
  mailOrder: FormInputMeta,
  schema: any,
}

const ListOfCardsToBeRenewedMeta: IListOfCardsToBeRenewedMeta = {} as IListOfCardsToBeRenewedMeta;

ListOfCardsToBeRenewedMeta.bank = commonFormMeta.bank;
ListOfCardsToBeRenewedMeta.agency = commonFormMeta.agency;
ListOfCardsToBeRenewedMeta.cardType = commonFormMeta.cardType;
ListOfCardsToBeRenewedMeta.internetOrder = commonFormMeta.internetOrder;
ListOfCardsToBeRenewedMeta.mailOrder = commonFormMeta.mailOrder;

ListOfCardsToBeRenewedMeta.nbMonths = {
  name: 'nbMonths',
  type: 'number',
  label: 'Nombre de mois',
  placeholder: '',
  validation: yup.string().required(),
};


ListOfCardsToBeRenewedMeta.schema = yup.object().shape(getValidationSchema(ListOfCardsToBeRenewedMeta));

export default ListOfCardsToBeRenewedMeta;

